export default "__VITE_ASSET__DlPmdOwF__"